import {useSelector} from 'react-redux';

import {selectOverallComment} from '../../../store/carAudit/selectors';
import {ParamType} from '../../../types/ParamType';
import {getFormFieldName} from '../utils/getFormFieldName';

export function useOverallComment() {
  const category = useSelector(selectOverallComment);

  const paramDefinition = category?.paramDefinitions?.additionalInformation?.find(
    (paramDefinition) => paramDefinition.type === ParamType.ADDITIONAL_COMMENT
  );

  if (!category || !paramDefinition) {
    return {
      category: null,
      paramDefinition: null,
      fieldName: null,
    };
  }

  const fieldName = getFormFieldName(category.id, paramDefinition.id);

  return {
    category,
    paramDefinition,
    fieldName,
  };
}
